// 정산일, 급여일 등 날짜 지정 배열 데이터
export const selectDateOfMonthArr = () => {
  const arr = [];
  for (let i = 1; i < 30; i++) {
    arr.push({ value: i.toString(), label: `${i}일` });
  }
  arr.push({ value: '말일', label: `말일` });
  return arr;
};

// 급여명세서 부양가족 수
export const selectDependentOfPayStatementArr = [
  { value: 1, label: '1명 (본인)' },
  { value: 2, label: '2명' },
  { value: 3, label: '3명' },
  { value: 4, label: '4명' },
  { value: 5, label: '5명' },
  { value: 6, label: '6명' },
  { value: 7, label: '7명' },
];
// 급여유형
export const payTypeOptions = [
  { value: '0', label: '시급' },
  { value: '1', label: '일급' },
  { value: '2', label: '월급' },
];
// 소득신고 유형
export const deducTypeOptions = [
  { value: '2', label: '4대보험' },
  { value: '1', label: '3.3%' },
  { value: '0', label: '없음' },
];
// 직책
export const positionOptions = [
  { value: '0', label: '스태프' },
  { value: '1', label: '매니저' },
];
// 요일 선택
export const daysOfWeekOptions = [
  { value: '1', label: '월' },
  { value: '2', label: '화' },
  { value: '3', label: '수' },
  { value: '4', label: '목' },
  { value: '5', label: '금' },
  { value: '6', label: '토' },
  { value: '0', label: '일' },
];
// 직책
export const positionTypeOptions = [
  { value: '0', label: '스태프' },
  { value: '1', label: '매니저' },
];

// 근무유형
export const calendarTypeOptions = [
  { value: '0', label: '고정근무' },
  { value: '1', label: '자율출퇴근' },
];
